import React, { useEffect } from 'react';
import { Navigate, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { staffToken } from '../lib/api';
import Logo from './Logo';

const link = ({ isActive }) =>
  `rounded-lg px-3 py-2 text-sm font-medium ${isActive ? 'bg-primary text-white' : 'text-muted hover:bg-cream hover:text-ink'}`;

// Staff pages. Signed-out visitors go to the sign-in page; an expired token
// (any 401 from the API) signs out everywhere via the weicare:signed-out event.
const StaffLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const out = () => navigate('/staff/login', { replace: true, state: { from: location.pathname, expired: true } });
    window.addEventListener('weicare:signed-out', out);
    return () => window.removeEventListener('weicare:signed-out', out);
  }, [navigate, location.pathname]);

  if (!staffToken.get()) return <Navigate to="/staff/login" replace state={{ from: location.pathname }} />;

  const signOut = () => { staffToken.clear(); navigate('/staff/login', { replace: true }); };

  return (
    <div className="min-h-screen bg-cream">
      <header className="border-b border-line bg-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-2 px-4 py-3">
          <span className="mr-4 flex items-center gap-2 font-bold text-primary"><Logo className="h-7" /> Staff</span>
          <NavLink to="/staff/contracts" className={link}>Contracts</NavLink>
          <NavLink to="/staff/settings" className={link}>Settings</NavLink>
          <NavLink to="/staff/deliveries" className={link}>Deliveries</NavLink>
          <NavLink to="/staff/account" className={link}>Account</NavLink>
          <button type="button" onClick={signOut} className="ml-auto text-sm text-muted hover:text-ink">Sign out</button>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default StaffLayout;
